'use strict';

var _ = require('lodash');
var d3 = require('d3');

var sankeyPaths = {};

sankeyPaths.getSankeyProps = function (data, dataParallelPlot, similarPatientsFilter, index, graphProps) {

  if (index === 0) {
    data.columnHeight = graphProps.graph.columns.height;
    data.baseY = 0;
  } else {
    var prevColumnID = dataParallelPlot[index - 1].column.id;
    data.columnHeight = dataParallelPlot[index - 1].columnHeight;

    if (similarPatientsFilter.columnSelection[prevColumnID]) {
      data.columnHeight = 0;
      _.each(similarPatientsFilter.columnSelection[prevColumnID], function (column) {
        data.columnHeight += dataParallelPlot[index - 1].column.categories[column.category].height;
      });
    };

    if (data.columnHeight === 0) data.columnHeight = dataParallelPlot[index - 1].columnHeight;

    data.baseY = (graphProps.graph.columns.height - data.columnHeight) / 2;
    data.baseY = 0;
  }
};

sankeyPaths.setRelations = function (dataParallelPlot, similarPatientsFilter, sourceCat, index, graphProps, bandWidth) {

  //console.log(D3Sankey.sankeyPatientsFilter)
  sourceCat.relations = [];
  if (index === 0) return;

  _.each(dataParallelPlot[index - 1].dataCategories, function (targetCat, i) {

    var sankeyPatients = 0;
    _.each(targetCat.patients, function (tp) {
      var match = _.find(sourceCat.patients, function (cp) {
        return tp.patientID === cp.patientID;
      });
      if (match) {

        if (similarPatientsFilter.patients.length > 0) {
          var similar = _.find(similarPatientsFilter.patients, function (sp) {
            return sp.patientID === match.patientID;
          });
          if (similar) sankeyPatients++;
        } else {
          sankeyPatients++;
        }
      }
    });

    var relation = {
      source: {},
      target: {},
      width: bandWidth - graphProps.graph.columns.width,
      offsetX: -graphProps.graph.columns.width / 2,
      patients: sankeyPatients
    };

    relation.source = {
      category: sourceCat.category,
      value: sankeyPatients,
      patients: sourceCat.patients.length,
      x: sourceCat.x,
      height: sankeyPatients / sourceCat.patients.length * sourceCat.height,
      baseY: sourceCat.y
    };

    relation.target = {
      category: targetCat.category,
      value: sankeyPatients,
      patients: targetCat.patients.length,
      x: sourceCat.y,
      height: sankeyPatients / targetCat.patients.length * targetCat.height,
      baseY: targetCat.y
    };

    sourceCat.relations.push(relation);
  });
};

sankeyPaths.updatePatients = function (props) {

  var gCatRelations = props.gCatRelations;
  var dataParallelPlot = props.dataParallelPlot;
  var categoryColumn = props.categoryColumn;
  var tweenTime = props.tweenTime;

  var gRelations = gCatRelations.selectAll('#gRelation').data(dataParallelPlot, function (d) {
    return d.column.id;
  });

  gRelations.enter().append('g').attr('id', 'gRelation').attr("transform", function (d, i) {
    d.bandwidth = getBandwidth(d.column.x, i);
    return "translate(" + d.column.x + "," + 0 + ")";
  }).each(function (d, i) {
    var g = d3.select(this);
    _.each(d.dataCategories, function (c, index) {
      categoryColumn.updateSankeyRelations(g, c, index, d.bandwidth, tweenTime);
    });
  });

  gRelations.attr("transform", function (d, i) {
    d.bandwidth = getBandwidth(d.column.x, i);
    return "translate(" + d.column.x + "," + 0 + ")";
  }).each(function (d) {
    var g = d3.select(this);
    _.each(d.dataCategories, function (c, index) {
      categoryColumn.updateSankeyRelations(g, c, index, d.bandwidth, tweenTime);
    });
  });

  gRelations.exit().remove();

  function getBandwidth(x, index) {
    var bandwidth = 0;
    if (index > 0) {
      bandwidth = x - dataParallelPlot[index - 1].column.x;
    };
    return bandwidth;
  }
};

module.exports = sankeyPaths;